const BASE = '/api';

export async function fetchCompetitions() {
  const res = await fetch(`${BASE}/competitions`);
  if (!res.ok) throw new Error('Failed to load competitions');
  return res.json();
}

export async function fetchSchedule(sport, competitionConfigId) {
  const res = await fetch(`${BASE}/schedule/${sport}/${competitionConfigId}`);
  if (!res.ok) throw new Error('Failed to load schedule');
  return res.json();
}

export async function fetchPreview(sport, competitionConfigId) {
  const res = await fetch(`${BASE}/preview/${sport}/${competitionConfigId}`);
  if (!res.ok) throw new Error('Failed to load preview');
  return res.json();
}

export async function generateFile(sport, competitionConfigId) {
  const res = await fetch(`${BASE}/generate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sport, competitionConfigId })
  });
  if (!res.ok) throw new Error('Failed to generate file');
  return res.blob();
}

export async function fetchAdminTeams() {
  const res = await fetch(`${BASE}/admin/teams`);
  if (!res.ok) throw new Error('Failed to load teams');
  return res.json();
}

export async function saveTeamConfig(filename, config) {
  const res = await fetch(`${BASE}/admin/teams/${filename}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(config)
  });
  if (!res.ok) throw new Error('Failed to save team config');
  return res.json();
}

export async function deleteTeamConfig(filename) {
  const res = await fetch(`${BASE}/admin/teams/${filename}`, {
    method: 'DELETE'
  });
  if (!res.ok) throw new Error('Failed to delete team config');
  return res.json();
}

export async function fetchAdminLeagues() {
  const res = await fetch(`${BASE}/admin/leagues`);
  if (!res.ok) throw new Error('Failed to load leagues');
  return res.json();
}

export async function saveLeagueConfig(configFile, config) {
  const res = await fetch(`${BASE}/admin/leagues/${configFile}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(config)
  });
  if (!res.ok) throw new Error('Failed to save league config');
  return res.json();
}

export async function deleteUnmatchedSoccerTeams(activeIds) {
  const res = await fetch(`${BASE}/admin/teams/delete-unmatched`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ activeIds })
  });
  if (!res.ok) throw new Error('Failed to delete unmatched teams');
  return res.json();
}

export async function fetchTeamLeagueIndex() {
  const res = await fetch(`${BASE}/admin/team-league-index`);
  if (!res.ok) throw new Error('Failed to load team-league index');
  return res.json();
}

export async function syncAllLeagueTeams() {
  const res = await fetch(`${BASE}/admin/leagues/sync-all-teams`, { method: 'POST' });
  if (!res.ok) throw new Error('Failed to sync all leagues');
  return res.json();
}

export async function fetchTeamConfig(filename) {
  const res = await fetch(`/api/admin/teams/${filename}/config`);
  if (!res.ok) throw new Error('Failed to load team config');
  return res.json();
}

export async function fetchOctopusStatus() {
  const res = await fetch(`${BASE}/octopus/status`);
  if (!res.ok) throw new Error('Failed to load Octopus status');
  return res.json();
}

export async function pushToOctopus(sport, competitionConfigId, options = {}) {
  const res = await fetch(`${BASE}/octopus/push/${sport}/${competitionConfigId}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(options)
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to push to Octopus');
  return data;
}
